export interface ExternalServicesSettingsInput {
    omnisend: OmnisendSettingsInput;
    gtag: GtagSettingsInput;
    clarity: ClaritySettingsInput;
    tawkio: TawkioSettingsInput;
}

export interface OmnisendSettingsInput {
    enabled: boolean;
    brandId: string;
    apiKey?: string;
}

export enum GtmMode {
    CLIENT_SIDE = 'CLIENT_SIDE',
    SERVER_SIDE = 'SERVER_SIDE'
}
export interface GtagSettingsInput {
    enabled: boolean;
    trackingId: string;
    mode: GtmMode;
}

export interface ClaritySettingsInput {
    enabled: boolean;
    trackingId: string;
}

export interface TawkioSettingsInput {
    enabled: boolean;
    embedChatId: string;
}
